import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findLoginInfo({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`loginInfo/findLoginInfo`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  clear() {
		return new Promise((resolve, reject) => {
			axios.get(`loginInfo/clear`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  }
}